import { AnyAction, Dispatch, Middleware } from 'redux'

/**
 * action を datadog に送る
 * @param store
 */
export const userActionLogger: Middleware = store => (next: Dispatch<AnyAction>) => action => next(action)
